import React, {useEffect, useRef} from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  TableRow,
  TableCell,
  Tooltip,
  Typography
} from '@material-ui/core';
import {DeleteOutlined, ExpandLess, ExpandMore} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckIcon from '@material-ui/icons/Check';
import {PrivateWealthWarningChip} from "../../shared/Chips";
import SortableTable from "../../shared/Tables/SortableTable";
import {Skeleton} from "@material-ui/lab";
import {makeStyles} from "@material-ui/styles";
import {TrashIcon} from "../../../user/shared/Icons";
import RiaWarningChip from "../../shared/Chips/RiaWarningChip";

const useStyles = makeStyles((theme) => ({
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  tabActive: {
    color: '#1E69E5',
  },
  inheritFontWeight: {
    fontWeight: 'inherit',
  },
}));

const WarningsSection = ({ warnings, setWarnings, fetching, tab, handleTabChange, scroll,...props }) => {
  const classes = useStyles();
  const warningRef = useRef(null);

  useEffect(() => {
    if (scroll) {
      if (!fetching) {
        warningRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [fetching]);

  const updateWarningStatus = async (warning, status) => {
    setWarnings(prevState => {
      const newState = prevState.map(obj => {
        if (obj.id === warning.id) {
          return {...obj, status, modified: true};
        }
        return obj;
      });
      return newState;
    });
  }

  return(
      <div className={classes.contentSection} ref={warningRef}>
        <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 'warnings')}>
          <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 'warnings' ? classes.tabActive : ''}`}>Warnings</Typography>
          {tab === 'warnings' ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={tab === 'warnings'}>
          <div className={classes.contentSectionContent}>
            <div className={classes.formGroup}>
              {
                fetching ? <Skeleton animation='pulse' variant='rect' height='100px' width='100%' component='div' /> : <SortableTable
                    headCells={[
                      { id: 'status', numeric: false, disablePadding: false, label: 'Status', sortable: true },
                      { id: 'description', numeric: false, disablePadding: false, label: 'Description', sortable: true },
                      { id: 'type_of_warning', numeric: false, disablePadding: false, label: 'Type', sortable: true },
                      { id: 'options', numeric: false, disablePadding: false, label: null },
                    ]}
                    rows={warnings}
                    RowRenderer={
                      (row, _isSelected, index, _handleCheck) => (<TableRow
                          hover
                          tabIndex={-1}
                          key={row.id}
                          style={{cursor: "pointer"}}
                          onClick={(event) => (row.id)}
                      >
                        <TableCell>
                          <RiaWarningChip
                              type={row.status}
                          />
                        </TableCell>
                        <TableCell>
                          {row.description}
                        </TableCell>
                        <TableCell>
                          <RiaWarningChip
                              type={row.type_of_warning}
                          />
                        </TableCell>
                        <TableCell style={{display: "flex"}}>
                          <Tooltip title={row.type_of_warning === 'allowed_domain' ? 'Reject Domain' : "Ignore"}>
                            <IconButton edge="end" aria-label="ignore" onClick={(event) => updateWarningStatus(row, "ignored")} disabled={row.status !== 'pending'}>
                              <DeleteOutlined style={{marginTop: "16px"}}/>
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={row.type_of_warning === 'allowed_domain' ? 'Approve Domain' : "Resolve"}>
                            <IconButton edge="end" aria-label="resolve" onClick={(event) => updateWarningStatus(row, "resolved")} disabled={row.status !== 'pending'}>
                              <CheckIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>)
                    }
                />
              }
            </div>
          </div>
        </Collapse>
      </div>
  )
}

export default WarningsSection;